/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Memory_Source1Inputs */

const en_mk_mock_memory_source1 = /** @type {(inputs: Mk_Mock_Memory_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`from Dimas's correction`)
};

const id_mk_mock_memory_source1 = /** @type {(inputs: Mk_Mock_Memory_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dari koreksi Dimas`)
};

/**
* | output |
* | --- |
* | "from Dimas's correction" |
*
* @param {Mk_Mock_Memory_Source1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_memory_source1 = /** @type {((inputs?: Mk_Mock_Memory_Source1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Memory_Source1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_memory_source1(inputs)
	return en_mk_mock_memory_source1(inputs)
});